import { SIZE, VARIANT } from "@/shared/models/legacy-constants";
import { Button, icons, IconWrapper } from "@/shared/ui";

interface CallToActionProps {
  title: string;
  description?: string;
  buttonText: string;
  onClick: () => void;
}

export const CallToAction = ({
  title,
  description,
  buttonText,
  onClick,
}: CallToActionProps) => {
  return (
    <section className="flex flex-col justify-between gap-3 rounded-2xl bg-secondary-50 p-4 text-secondary-950 lg:flex-row lg:items-center">
      <div className="flex flex-col md:text-center lg:gap-2.5 lg:text-left lg:text-lg">
        <h3 className="font-semibold">{title}</h3>
        {description && <p>{description}</p>}
      </div>

      <Button
        variant={VARIANT.SECONDARY}
        size={SIZE.LARGE}
        onClick={onClick}
        className="w-full lg:w-fit"
      >
        {buttonText}
        <IconWrapper size={SIZE.SMALL}>
          <icons.ArrowRight />
        </IconWrapper>
      </Button>
    </section>
  );
};
